module.exports = __webpack_public_path__ + "img/gongchang.e7cf0fa4.png";